    
<template>

    <a-row :gutter="[16,16]" id="homeWarnChartBox">
      <a-col :span="24">
        <a-card title="异常统计" :bordered="false">
            <a-button type="link" @click="handleToMonitor" slot="extra">异常监控<a-icon type="arrow-right" /></a-button>
            <qschart :data="sumData" :chartID="'homeqschart'"  class="home_chart"></qschart>         

            <zbpie :data="sumData" class="home_chart" style="border-left:1px solid lightgray;"></zbpie>   
        </a-card>
      </a-col>
    </a-row>
</template>

<script>
import qschart from '../monitorerror/overview/qschart'

import zbpie from '../monitorerror/overview/zbpie'

export default {
    data() {
        return {
            sumData:{
                listthread:[],
                listerrorsys:[],
                isoverview:true,
                isperhour:true,
            },
            
        }
    },
    methods: {
        handleToMonitor(){
            this.$router.push({
                path:'/monitorerror/overview',
                query: {
                }
            }); 
        },
        getOverviewData(){
            let that = this;
            let params = {
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/queryoverview",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == 1){
                    that.sumData = res.data.data;
                    that.sumData.isoverview = true;
                    that.sumData.isperhour = true;
                }
            }).catch(() => {
                that.message.error("调用接口异常")
            });
        }

    },
    mounted() {
        this.getOverviewData();
    },
    destroyed(){
    },
    components:{
        qschart,
        zbpie
    }
}
</script>

<style scoped>
   .home_chart{
       float: left;
       width:calc(50%);
        border-left: none;
        border-right: none;
   }
</style>
<style>
    #homeWarnChartBox .ant-card-body{
        padding: 0;
    }

    #homeWarnChartBox .dashTitle{
        border-bottom: none;
    }
</style>
